import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from 
         '@angular/material/dialog';

interface PopupNotificationData 
{
    title: string;
    content: string;
    showOk?: boolean;
    closedButtonLabel?: string;
    okButtonLabel?: string;
}

@Component({
    template: `
        <h5 mat-dialog-title>
            {{data.title}}
        </h5>
        <div mat-dialog-content>
            {{ data.content }}
        </div>
        <div mat-dialog-actions>                
            <button *ngIf="data.showOk" mat-raised-button 
                    color="primary"
                    (click)="okDialog()">{{ getOkLabel() }}</button>
            <button mat-raised-button 
                    color="accent"
                    (click)="closeDialog()">
            {{ data.closedButtonLabel }} </button>
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
class PopupNotificationComponent 
{
    title: string = '';
    content: string = '';

    constructor
    (
        public dialogRef: MatDialogRef<PopupNotificationComponent>,
        @Inject(MAT_DIALOG_DATA) public data: PopupNotificationData
    )
    {
        
    }

    getOkLabel
    (
    ): string
    {
        let label;

        label = this.data && this.data.okButtonLabel ?
            this.data.okButtonLabel : 'OK';

        return label;
    }
    
    closeDialog
    (
    )
    {
        this.dialogRef.close(false);    
    }
    
    okDialog
    (
    )
    {
        this.dialogRef.close(true);    
    }
    
}

export { PopupNotificationComponent };
